import 'Styles/portalpage.scss';
import postscribe from 'postscribe';

import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';

import portalPageSelector from 'Selectors/portalPageSelector';
import { fetchPortalPage } from 'Actions/PortalPageActions';
import { trackPageView, checkAdsPermissions, onPageView } from 'Actions/adsActions';
import { getLandingPage } from "Actions/UserSettingsActions";

import Breadcrumb from 'Components/common/BreadcrumbComponent';
import AdComponent from 'Components/ads/AdComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

class PortalPageComponent extends React.Component {
	componentDidMount() {
		if( this.props.params.pagename ) {
			this.props.dispatch( fetchPortalPage( {
				pagename: this.props.params.pagename
			} ) );
		} else {
			// Go to landing page
			let landingPage = this.props.dispatch( getLandingPage() );
			this.props.dispatch( replace( landingPage ) );
		}
	}

	componentWillReceiveProps(nextProps) {
		if( nextProps.portalpage.isFetching === false ) {
			this.props.dispatch( checkAdsPermissions( -1 ) );
		}
		if( nextProps.portalpage.loaded && nextProps.portalpage.loaded !== this.props.portalpage.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	componentDidUpdate() {
		window.scrollTo( 0, 0 );

		if( this.props.portalpage.isFetching === false ) {
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );

			// Some scripts allowed to run in the pages when they are needed
			let scripts = [
				{
					type: 'twitter',
					script: ( 'https:' === document.location.protocol ? 'https://' : 'http://' ) + 'platform.twitter.com/widgets.js',
					selector: ".twitter-share-button",
				}
			];
			scripts.forEach( ( script ) => {
				// do we have the element needed?
				if( this.thePageContainer.querySelector( script.selector ) ) {
					// load the script
					let src = script.script;
					postscribe( this.thePageContainer, '<script type="text/javascript" src="' + src + '"></script>', {
						done: function() {
							topifyConsole.log( "loading:", script.type );
						},
						error: function() {
							topifyConsole.warn( 'error loading: ', script.type );
						}
					} );
				}
			}, this );
		}
	}

	get getPage() {
		let page = false;
		if( this.props.params.pagename && this.props.portalpage.entities.page ) {
			page = this.props.portalpage.entities.page[ this.props.params.pagename ] || false;
		}
		return page;
	}

	getAdComponents() {
		const forumSite = this.props.topifyPresets.forumSite;
		let dfpTags;

		if( forumSite.dfpTags ) {
			dfpTags = JSON.parse( forumSite.dfpTags );
		}

		let adUnits = dfpTags.filter( function( ad ) {
			return ( parseInt( ad.at_id ) >= 50 && parseInt( ad.at_id ) <= 59 );
		} );

		if( adUnits ) {
			return adUnits.map( ( unit ) => {
					let adName = /(?:\/[^/]+\/)?(.*)/ig.exec( unit.fda_path );
					if( adName.length === 2 ) {
						return <AdComponent key={ adName[ 1 ] } adType={ unit.at_id } adName={ adName[ 1 ] }/>
					} else {
						return null;
					}
				}
			);
		}
		return null;
	}

	render() {
		if( !this.props.portalpage.loaded ) {
			return <LoaderCss />;
		}

		if( this.getPage && this.getPage.content ) {
			let ads = this.getAdComponents();
			return (
				<div>
					<Breadcrumb routeParams={this.props.routeParams} />
					<div className="portalPage" ref={ (ref) => this.thePageContainer = ref }>
						{ ads }
						<div key="page" dangerouslySetInnerHTML={{ __html: this.getPage.content }}/>
					</div>
				</div>
			);

		} else {
			return <div>There is no content to show</div>;
		}
	}
}

export default connect( portalPageSelector )( PortalPageComponent );



// WEBPACK FOOTER //
// ./src/components/PortalPageComponent.js